var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cnpj"}},[_c('p',[_vm._v("SOCIEDADE TECNICA EDUCACIONAL DA LAPA S/A")]),_c('p',[_vm._v("CNPJ: 02.558.975/0001-65")])])}]

export { render, staticRenderFns }